import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import DownloadPdf from '../DownloadPdf';

import { ActionColor, ActionShadeColor, ActionTextColor } from '../styles/colors';
import { ActionFont } from '../styles/fonts';

const DEFAULT_LABEL = 'Gesamtes Material herunterladen';

const A = styled(DownloadPdf)`
  display: inline-flex;
  align-items: center;
  justify-content: center;

  ${ActionFont};
  font-size: 22px;

  text-decoration: none;
  text-transform: uppercase;
  cursor: pointer;

  line-height: 1.2;

  background-color: ${ActionColor};
  color: ${ActionTextColor};

  &:hover, &:visited {
    color: ${ActionTextColor};
    text-decoration: none;
    background-color: ${ActionShadeColor};
  }
`;

const IconImg = styled.div`
  margin: 0 .5em;
`;

const Label = styled.span`
  text-align: center;
  display: inline-block;
`;

const DownloadIcon = () => (
  <IconImg>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33 33" width="33" height="33">
      <path fill="currentColor" d="M12.26,0h8.35a.73.73,0,0,1,.78.69V14.37h3.49a.68.68,0,0,1,.61,1.11L17,24.68a.84.84,0,0,1-1.22,0l-8.44-9.2A.68.68,0,0,1,8,14.37h3.48V.69A.74.74,0,0,1,12.26,0" transform="translate(0 0)" />
      <path fill="currentColor" d="M2.05,28.76H30.81a2.06,2.06,0,1,1,0,4.11H2.05a2.06,2.06,0,0,1,0-4.11" transform="translate(0 0)" />
    </svg>
  </IconImg>
);

const renderIcon = noicon => (noicon ? null : <DownloadIcon />);

const renderLabel = (nolabel, label) => (nolabel ? null : (
  <Label>{ label }</Label>
));

const DownloadMaterialButton = ({
  className,
  download,
  href,
  label,
  noicon,
  nolabel,
  nolink,
}) => (
  <A href={href} download={download} className={className} nolink={nolink}>
    { renderIcon(noicon, label) }
    { renderLabel(nolabel, label) }
  </A>
);

DownloadMaterialButton.propTypes = {
  nolabel: PropTypes.bool,
  noicon: PropTypes.bool,
  nolink: PropTypes.bool,
  label: PropTypes.string,
  className: PropTypes.string,
  href: PropTypes.string,
  download: PropTypes.string,
};

DownloadMaterialButton.defaultProps = {
  nolabel: false,
  noicon: false,
  nolink: false,
  label: DEFAULT_LABEL,
  className: undefined,
  href: undefined,
  download: undefined,
};

export default DownloadMaterialButton;



// WEBPACK FOOTER //
// ./src/components/DownloadMaterialButton/DownloadMaterialButton.js